import { format } from 'date-fns'

export const nowISOString = () => new Date().toISOString()
export const formatToDateString = (date: Date) => format(date, 'yyyy-MM-dd')
